"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.AccordionItem = void 0;
var react_1 = __importDefault(require("react"));
var ToggleContainer_1 = require("../ToggleContainer");
var AccordionContext_1 = require("./AccordionContext");
var AccordionItem = function (_a) {
    var item = _a.item, className = _a.className, title = _a.title, children = _a.children, rest = __rest(_a, ["item", "className", "title", "children"]);
    var _b = AccordionContext_1.useAccordionContext(), currentItem = _b.currentItem, changeItem = _b.changeItem;
    return (react_1["default"].createElement(ToggleContainer_1.ToggleContainer, __assign({ className: ['accordion_item', className], opened: currentItem === item, onChanging: function () {
            changeItem(item);
        } }, rest),
        react_1["default"].createElement(ToggleContainer_1.ToggleContainer.Trigger, null, title),
        react_1["default"].createElement(ToggleContainer_1.ToggleContainer.Content, null, children)));
};
exports.AccordionItem = AccordionItem;
//# sourceMappingURL=AccordionItem.js.map